// extracted by mini-css-extract-plugin
export var chevron = "_33-d";
export var disabled = "_33-b";
export var error = "_33-c";
export var hideBorder = "_33-1";
export var icon = "_33-e";
export var input = "_33-0";
export var open = "_33-9";
export var placeholder = "_33-a";
export var regular = "_33-5";
export var singleRowInput = "_33-2";
export var singleSelectInput = "_33-3 _33-0";
export var small = "_33-4";
export var spinnerContainer = "_33-g";
export var tag = "_33-7";
export var tagsContainer = "_33-8";
export var tagsInput = "_33-6 _33-0";
export var xSmall = "_33-f";